import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as SettingsActions from '../../../state/actions/message-settings'
import MissedCallMessage from './MissedCallMessage'
import buildTextEditor from '../buildTextEditor'
import { logException } from '../../../services/sentry'
import styles from '../NewAppointmentMessageEditor/styles.css'

const MissedCallText = buildTextEditor(MissedCallMessage)

class MissedCallMessageEditor extends React.Component {
  static propTypes = {
    activateSetting: PropTypes.func,
    deactivateSetting: PropTypes.func,
    hasPlum: PropTypes.bool,
    maxChars: PropTypes.number.isRequired,
    missedCallText: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    pmsType: PropTypes.string,
    pmsVersion: PropTypes.number,
    updateMessageSetting: PropTypes.func,
  }
  constructor(props) {
    super(props)
    this.state = {
      isHelpOpen: false,
    }
  }

  toggleHelp = () => {
    this.setState({ isHelpOpen: !this.state.isHelpOpen })
  }

  updateSetting = ({ body, subject, always_send }) => {
    const { missedCallText } = this.props
    const settingId = subject ? missedCallEmail.id : missedCallText.id
    const changes = {
      body,
      subject,
      always_send,
    }

    return this.props
      .updateMessageSetting(settingId, changes)
      .then(() => {
        if (!body.text.trim()) {
          this.props.deactivateSetting(settingId)
        }
      })
      .catch((err) => {
        logException(err)
      })
  }

  render() {
    const { isHelpOpen } = this.state
    const {
      activateSetting,
      deactivateSetting,
      hasPlum,
      maxChars,
      missedCallText,
      pmsType,
      pmsVersion,
    } = this.props

    return (
      <div className={`${styles.container} CallTextSettingEditor`}>
        <h1>Missed Call Messaging</h1>
        <div className={styles.missedCallMessagesWrapper}>
          {missedCallText ? (
            <MissedCallText
              key={missedCallText.id}
              hasPlum={false}
              hasReviews={false}
              maxChars={maxChars}
              pmsType={pmsType}
              pmsVersion={pmsVersion}
              setting={missedCallText}
              title="Missed Call Text"
              updateSetting={this.updateSetting}
              activateSetting={activateSetting}
              deactivateSetting={deactivateSetting}
            />
          ) : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasPlum, pmsType, pmsVersion },
  },
}) => ({
  hasPlum,
  pmsType,
  pmsVersion,
})

const mapDispatchToProps = dispatch => ({
  updateMessageSetting: (settingId, changes) => dispatch(SettingsActions.updateMessageSetting(settingId, changes)),
  activateSetting: (settingId, opts) => dispatch(SettingsActions.activateSetting(settingId, opts)),
  deactivateSetting: (settingId, opts) => dispatch(SettingsActions.deactivateSetting(settingId, opts)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MissedCallMessageEditor)


// WEBPACK FOOTER //
// ./src/components/Settings/MissedCallMessageSetting/index.js